import axios from 'axios';

import { DASHBOARD } from './types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

/* Dashboard */
export const buscarDashboard = (tipo) => async dispatch => {
    try {
        if(tipo){
            await dispatch(changeLoader(true));
            const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/dashboard/${tipo}`);

            await dispatch({
                type: DASHBOARD.OBTENER,
                payload: res.data.datos
            });
        }else{
            await dispatch({
                type: DASHBOARD.OBTENER,
                payload: null
            });
        }
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}